module.exports = __webpack_public_path__ + "img/logo-2.0f986693.png";